import cn from 'classnames';

import { Button, Space, Typography } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';

import { sendPromotionClickEvent } from '@src/helpers/analyticsEvents';

import styles from './styles.module.scss';

const { Heading, Text } = Typography;

export type CardProps = {
  organization: any; // Pick<IOrganization, 'hzhzhzhzhzh'>;
  title: string;
  text: string;
  backgroundColor: string;
  buttonText?: string;
  textColor: string;
  promoLink: string;
  mobileBackgroundImage?: (props: { className: string }) => JSX.Element;
  desktopBackgroundImage?: (props: { className: string }) => JSX.Element;
};

export const Card = ({
  organization,
  title,
  text,
  backgroundColor,
  buttonText = 'Участвовать',
  textColor,
  mobileBackgroundImage,
  desktopBackgroundImage,
  promoLink,
}: CardProps) => {
  const isMobile = useIsMobile();

  const BackgroundImage = isMobile ? mobileBackgroundImage : desktopBackgroundImage;
  const organizationName = organization.name ?? 'DefaultOrgName';

  return (
    <div
      className={styles.card}
      style={{
        background: backgroundColor,
        color: textColor,
      }}
    >
      <Space className={cn(styles.header, 'h-mb-16')} size={8}>
        <img src={organization.logotypes?.android} alt="logo" className={styles.logo} />
        <Heading level={6}>{organizationName}</Heading>
      </Space>
      <Space size={8} direction="vertical" className={styles.textContent}>
        <Heading level={4}>{title}</Heading>
        <Text size={12} className="h-mb-24">
          {text}
        </Text>
      </Space>
      {BackgroundImage && <BackgroundImage className={styles.image} />}
      <a href={promoLink} target="_blank" rel="noreferrer" className={styles.link}>
        <Button
          onClick={() => sendPromotionClickEvent(organizationName)}
          size={44}
          className={styles.button}
          variant="primary"
          block={isMobile}
        >
          {buttonText}
        </Button>
      </a>
    </div>
  );
};
